import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import calculateAvatarScale from "../../helpers/avatar/calculateAvatarScale";
import { getContrastingTextColor } from "../../util/ColorUtil";

export default function Avatar({ userData, ...props }) {
  const profileAvatar = userData?.profile_avatar || {};
  const {
    image_url,
    icon_data,
    position_x,
    position_y,
    natural_width,
    natural_height,
    scale,
    avatar_type,
    background_color,
    color,
    userDetail = false,
  } = profileAvatar;

  const userColor = userData?.color;
  // Default avatar greys are placeholders — prefer the user's profile color.
  const defaultAvatarBackgrounds = new Set([
    "rgb(228, 228, 228)",
    "rgb(189, 186, 186)",
  ]);
  const avatarBackground =
    background_color && !defaultAvatarBackgrounds.has(background_color)
      ? background_color
      : null;
  const backgroundColor = avatarBackground || userColor || "rgb(189, 186, 186)";
  const textColor = color || getContrastingTextColor(backgroundColor);
  const usersInitials = userData
    ? `${userData.first_name?.[0] ?? ""}${userData.last_name?.[0] ?? ""}`
    : "";

  const renderUserAvatar = () => {
    switch (avatar_type) {
      case "icon": {
        return (
          <FontAwesomeIcon
            icon={icon_data}
            size="lg"
            style={{
              color: textColor,
            }}
          />
        );
      }
      case "initials": {
        return usersInitials;
      }
      case "image": {
        return (
          <div
            className="avatar-image"
            style={{
              backgroundImage: `url(${image_url})`,
              backgroundPosition: `${position_x}% ${position_y}%`,
              backgroundSize: calculateAvatarScale(
                natural_width,
                natural_height,
                scale
              ),
            }}
          />
        );
      }
      default:
        return usersInitials;
    }
  };

  return (
    <div
      className="avatar-container"
      style={{
        backgroundColor: backgroundColor,
        color: textColor || "black",
      }}
      {...props}
    >
      {renderUserAvatar()}
    </div>
  );
}
